import { Table, TableContainer } from '@ksyos/design-system';
import type { FundingErrorInformation } from '@common/enums/fundingErrorInformation';
import type { FundingProcess } from '@common/interfaces/api/fundingProcessApi';
import { FinancingFlexTableBody } from './FinancingFlexTableBody';
import { FinancingFlexTableHeader } from './FinancingFlexTableHeader';

type FinancingFlexTableProps = {
    allItemsSelected: boolean;
    items: FundingProcess[];
    onChangeFundingErrorInformation: (processNumber: number, value?: FundingErrorInformation) => void;
    onSelectAll: (value: boolean) => void;
    onSelectRow: (row: FundingProcess) => void;
    selectedRows: FundingProcess[];
};

export function FinancingFlexTable({
    items,
    allItemsSelected,
    onSelectAll,
    onChangeFundingErrorInformation,
    onSelectRow,
    selectedRows,
}: FinancingFlexTableProps) {
    return (
        <TableContainer>
            <Table>
                <FinancingFlexTableHeader
                    allItemsSelected={allItemsSelected}
                    hasItemsSelected={selectedRows.length > 0}
                    onSelectAll={onSelectAll}
                />
                <FinancingFlexTableBody
                    items={items}
                    onChangeFundingErrorInformation={onChangeFundingErrorInformation}
                    onSelectRow={onSelectRow}
                    selectedRows={selectedRows}
                />
            </Table>
        </TableContainer>
    );
}
